module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Globe-93f68765e58f60c89b0a707d9ec310ee.svg";